import { apiClient } from './apiClient';

const limitedAdminAPI = {
  // Dashboard
  getDashboardStats: () => apiClient.get('/limited-admin/dashboard/stats'),
  getRecentActivities: (hours = 24) => apiClient.get(`/limited-admin/dashboard/recent-activities?hours=${hours}`),

  // Data endpoints (filtered to assigned users only)
  getDocuments: (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    return apiClient.get(`/limited-admin/documents?${queryParams.toString()}`);
  },

  getTaskAssignments: (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    // Include document information in the response
    queryParams.append('include_document', 'true');
    return apiClient.get(`/limited-admin/task-assignments?${queryParams.toString()}`);
  },

  getAuditLogs: (params = {}) => {
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        queryParams.append(key, params[key]);
      }
    });
    // Add cache-busting parameter
    queryParams.append('_t', Date.now());
    return apiClient.get(`/limited-admin/audit-logs?${queryParams.toString()}`);
  },

  getDocumentFlow: (documentId) => apiClient.get(`/limited-admin/document-flow/${documentId}`),

  // User management
  getAssignedUsers: () => apiClient.get('/limited-admin/assigned-users'),

  // Super admin only endpoints
  assignUsers: (limitedAdminId, userIds) => 
    apiClient.post('/limited-admin/assign-users', { limitedAdminId, userIds }),

  removeUserAssignment: (limitedAdminId, assignedUserId) => 
    apiClient.delete('/limited-admin/remove-user-assignment', { 
      data: { limitedAdminId, assignedUserId } 
    }),

  getAllLimitedAdmins: () => apiClient.get('/limited-admin/all-limited-admins'),
  getLimitedAdmins: () => apiClient.get('/limited-admin/limited-admins')
};

export { limitedAdminAPI };
